import keycloakApi from './keycloak-auth';

export interface Note {
  id: string;
  entity_type: string;
  entity_id: string;
  note: string;
  created_by_id: string | null;
  created_by_name: string | null;
  created_by_party_name: string | null;
  created_at: string;
}

export interface PaginatedNotes {
  data: Note[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

const apiCall = async <T>(endpoint: string, options: RequestInit = {}): Promise<T> => {
  return keycloakApi.authenticatedApiCall<T>(endpoint, options);
};

export const getNotes = async (
  entity_type: string,
  entity_id: string,
  page = 1,
  limit = 5
): Promise<PaginatedNotes> => {
  const params = new URLSearchParams({
    entity_type,
    entity_id,
    page: String(page),
    limit: String(limit),
  });
  return apiCall<PaginatedNotes>(`/notes?${params.toString()}`);
};

export const createNote = async (
  entity_type: string,
  entity_id: string,
  note: string
): Promise<Note> => {
  return apiCall<Note>('/notes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entity_type, entity_id, note }),
  });
};
